import { useQuery } from '@tanstack/react-query';
import { api } from '~/lib/api-client';
import type { Region } from '~/components/model-badges';

export interface VoiceModel {
  id: string;
  provider?: string;
  /** FRONT-1034: real hosting region, cross-referenced server-side from the
   *  LiteLLM proxy catalogue. Absent means genuinely unknown — never assume
   *  a default here. */
  region?: Region;
  /** FRONT-2001: a human-facing name distinct from the wire id, e.g.
   *  "GPT-Live-1" for `gpt-live-1`. Absent for every entry that has none
   *  (every realtime entry today) — the picker falls back to its own
   *  id-derived headline in that case. */
  displayName?: string;
}

interface VoiceModelsResponse {
  models: VoiceModel[];
  default: string;
}

export function useVoiceModels() {
  return useQuery({
    queryKey: ['voice', 'models'],
    queryFn: () => api.get<VoiceModelsResponse>('/api/voice/models'),
    staleTime: 5 * 60_000,
    retry: 0,
  });
}
